exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2TxA-{position:relative;margin-bottom:0;background-color:#efe9d9;border-top:1px solid #d9d9d9}body.reader-night-mode ._2TxA-{background-color:#737373;border-color:#2e2e2e}", ""]);

// exports
exports.locals = {
	"note-list": "_2TxA-"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"localIdentName":"[hash:base64:5]","importLoaders":2}!./node_modules/postcss-loader/lib!./node_modules/sass-loader/lib/loader.js!./src/components/NoteList/NoteList.scss
// module id = +3lF
// module chunks = 3